export function getSafeHtml(rawHtml) {
    return escape(rawHtml);
}

const ESC = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '&': '&amp;'
};

function escape (s) {
    return s.replace(/[<>"&]/g, escapeChar)
}

function escapeChar (a) {
    return ESC[a] || a
}
